import { IconButton } from '@folio/stripes/components';
import React, { useCallback } from 'react';
import { useField } from 'react-final-form';
import { useFieldArray } from 'react-final-form-arrays';
export default function TokenCardToolbox(_a) {
    var fieldArrayName = _a.fieldArrayName, name = _a.name, index = _a.index, isLast = _a.isLast, showLengthControl = _a.showLengthControl;
    var fieldArray = useFieldArray(fieldArrayName);
    var lengthControlOpen = useField("".concat(name, ".lengthControl.drawerOpen"), {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    });
    var removeCallback = useCallback(function () { return fieldArray.fields.remove(index); }, [fieldArray.fields, index]);
    var lengthControlCallback = useCallback(function () { return lengthControlOpen.input.onChange(!lengthControlOpen.input.value); }, [lengthControlOpen]);
    var moveUpCallback = useCallback(function () { return fieldArray.fields.swap(index, index - 1); }, [fieldArray.fields, index]);
    var moveDownCallback = useCallback(function () { return fieldArray.fields.swap(index, index + 1); }, [fieldArray.fields, index]);
    return (React.createElement(React.Fragment, null,
        showLengthControl && React.createElement(IconButton, { icon: "gear", onClick: lengthControlCallback }),
        React.createElement(IconButton, { icon: "caret-up", disabled: index === 0, onClick: moveUpCallback }),
        React.createElement(IconButton, { icon: "caret-down", disabled: isLast, onClick: moveDownCallback }),
        React.createElement(IconButton, { icon: "trash", onClick: removeCallback })));
}
